import { styled } from '@mui/material/styles';

export const SidebarLogo = styled('img')`
  width: 165px;
  margin: 30px;
  min-height: 25px;
  object-fit: contain;
`;
